import * as Pages from "@/components/Pages";
import * as Paper from "@/components/PaperContainer";
import * as React from "react";

import { useLoadedData } from "./loader";

import { Form } from "./Form";

import { usePaths } from "@/routes/paths";
export function Page() {
  const paths = usePaths();
  const { project } = useLoadedData();

  return (
    <Pages.Page title={["Pausing", project.name!]}>
      <Paper.Root size="medium">
        <Paper.Navigation items={[{ to: paths.projectPath(project.id!), label: project.name! }]} />

        <Paper.Body minHeight="none">
          <div className="text-content-accent text-3xl font-extrabold">Приостановить этот проект?</div>
          <div className="text-content text font-medium mt-2">Приостановка этого проекта:<ul className="list-disc list-inside mt-4">
              <li>Приостановить все связанные этапы и задачи</li>
              <li>Остановить уведомления для участников команды</li>
              <li>Переместить проект в список приостановленных проектов</li>
            </ul>
            <p className="mt-4">Примечание: можно возобновить проект в любой момент.</p>
          </div>

          <div className="mt-8">
            <Form project={project} />
          </div>
        </Paper.Body>
      </Paper.Root>
    </Pages.Page>
  );
}
